import AllSelectionsTable from "./AllSelectionsTable";
export default AllSelectionsTable;
